/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

export default () => css`
    .version-tag {
        position: fixed;
        bottom: 0;
        right: 0;
        z-index: -1000;
        color: #c0c0c0;
    }
`;
